import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ChevronRight, Users } from 'lucide-react';
import { Badge, Card } from '@up2d8/ui';
import { useHasTeam } from './use-my-team';

/**
 * De kaart "Mijn team · 2 nog te bevestigen" op Home (Stap 17, TEAM-2, spec §1).
 *
 * De spec koos bewust tegen een zesde tab: alleen leidinggevenden hebben dit scherm, en een zesde
 * tab maakt elk raakvlak te smal. De kaart op Home is de plek waar een ploegbaas 's ochtends kijkt.
 *
 * **Wie geen team heeft, ziet geen kaart.** Niet een lege kaart met "0 openstaand": die belooft een
 * scherm dat niets zegt, en dan gaat de medewerker zoeken naar wat hij fout doet. Zolang het
 * antwoord nog laadt, staat er ook niets - een kaart die verschijnt is minder storend dan een die
 * verdwijnt.
 */
export function AppTeamCard() {
  const { t } = useTranslation();
  const { hasTeam, openPosts, loading } = useHasTeam();

  if (loading || !hasTeam) return null;

  return (
    <Card compact data-testid="team-home-card">
      <Link to="/app/team" className="flex items-center gap-element">
        <span
          aria-hidden
          className="rounded-pill bg-brand-primary-tint p-2 text-brand-primary-dark"
        >
          <Users className="h-5 w-5" />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block font-heading text-content font-semibold text-text-primary">
            {t('team.homeCard')}
          </span>
          <span className="block text-small text-text-muted">
            {openPosts > 0 ? t('team.homeCardOpen', { count: openPosts }) : t('team.homeCardDone')}
          </span>
        </span>
        {/* Het aantal ook als badge: een getal in een zin leest niemand van een afstand. */}
        {openPosts > 0 ? <Badge tone="orange">{openPosts}</Badge> : null}
        <ChevronRight aria-hidden className="h-5 w-5 shrink-0 text-text-muted" />
      </Link>
    </Card>
  );
}
